export interface ItemGroupInputs {
    id?: number;
    name: string;
    description?: string;
    sort_order: number;
}

export const ItemGroupInputsDefault: ItemGroupInputs = {
    name: "",
    description: "",
    sort_order: 50,
};
